import React, {useEffect, useState} from "react";
import {useForceUpdate} from "../../services/misc.functions";
import {homeHippodrome, homeHippodromeSubject} from "../../store/misc.store";
import {ApiService} from "../../lib/http.service";
import {changedJokeyUrlPrefix} from "../../constants/global.vars";
import {HippodromeWidget} from "../../shared/hippodrome/hippodrome";


let hippodromeList: any = [];

export function ChangedJockeys() {
    const forceUpdate = useForceUpdate();
    const [jokeyChanges, setJockeyChanges] = useState<any>([]);

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        let homeHippodromeSubject_subscription = homeHippodromeSubject.subscribe((res: any) => {
            if (hippodromeList.length === 0) {
                getData();
            } else {
                getHippodromejokeys();
            }

        })
        return () => {
            homeHippodromeSubject_subscription.unsubscribe();
        }
    }, []);


    const getData = () => {

        let api = new ApiService()
        api.start('get', changedJokeyUrlPrefix, null, false)
            .then((res: any) => {
                if (res.status) {
                    hippodromeList = res.data;
                    setTimeout(() => {
                        getHippodromejokeys();
                    }, 1000);

                } else {
                    hippodromeList = [];
                }
            })
    }

    const getHippodromejokeys = () => {
        var selectedHippodromeJokey;
        for (const hippodromeListElement of hippodromeList) {
            if (hippodromeListElement.keyword === homeHippodrome.keyword) {
                selectedHippodromeJokey = hippodromeListElement;
            }
        }
        if (selectedHippodromeJokey) {
            setJockeyChanges(selectedHippodromeJokey.jockey_changes);
        }
    }

    const getHorseName = (runNo: any, horseNo: any) => {
        try {
            var selectedRun = homeHippodrome.runs.filter((el: any) => Number(el.no) === Number(runNo));
            var selectedHorse = selectedRun[0].horseMap[horseNo];
            return selectedHorse.name;
        } catch (e: any) {
            return horseNo;
        }
    }

    return <>
        <div className="page-title-wrapper ">
            <HippodromeWidget/>
        </div>
        <div className={"container"}>
            {jokeyChanges.length > 0 &&
                <table className={"table w-100 widget-table changed-jockey-table"}>
                    <thead>
                    <tr>
                        <th>Koşu</th>
                        <th>At</th>
                        <th>Jokey</th>

                    </tr>
                    </thead>
                    <tbody>
                    {jokeyChanges?.map((jockey: any, runsIndex: number) => {
                        return (<React.Fragment key={`notRuningHorse-i-${runsIndex}`}>
                            <tr>
                                <td className="d-flex justify-content-center align-items-center align-content-center">{jockey.run_no}</td>
                                <td className="d-flex justify-content-center align-items-center align-content-center">

                                    ({jockey.horse_no}) <span className={"ms-1 text-truncate"}>{getHorseName(jockey.run_no, jockey.horse_no)}</span>
                                </td>
                                <td>
                                    <p className="text-xxsmall fw-medium d-flex align-items-center">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                             xmlns="http://www.w3.org/2000/svg" className="me-2">
                                            <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="white"></rect>
                                            <rect x="0.5" y="0.5" width="19" height="19" rx="9.5"
                                                  stroke="#E8E6D0"></rect>
                                            <path
                                                d="M12.9744 9.5241C12.7352 9.53708 12.4925 9.55233 12.2501 9.57119C11.4973 9.62941 10.8503 9.7092 10.3063 9.81124C9.41445 9.95786 8.54989 10.1627 7.82151 10.4492C6.5774 10.9382 5.62006 11.4654 4.93541 11.9047C4.56066 10.7176 3.89041 5.6833 8.47151 5.12701C8.55288 4.86059 8.78536 4.66666 9.06295 4.66666C9.3269 4.66666 9.55138 4.8414 9.64288 5.08755C11.6731 5.20757 12.7236 6.41117 13.2421 8.48304L15.3333 9.45641C14.7526 9.45466 13.9159 9.46665 12.9744 9.5241Z"
                                                fill="#353535"></path>
                                            <path
                                                d="M10.3811 12.602C9.8245 12.4828 8.49241 12.0943 8.53048 11.1097C8.54264 10.7967 8.9899 10.5504 9.69439 10.3625L10.3811 12.602Z"
                                                fill="#353535"></path>
                                            <path
                                                d="M10.0844 10.277C11.0314 10.1073 12.0314 10.0079 12.9403 9.95081L12.9606 9.97141L13.5515 11.4228C13.5662 11.4564 13.5732 11.4951 13.5732 11.5349C13.5732 11.6939 13.4475 11.8232 13.2912 11.8232H12.8214V12.8241C12.8214 13.6049 12.2038 14.2372 11.4407 14.2372H11.2989L10.0844 10.277Z"
                                                fill="#353535"></path>
                                            <path
                                                d="M9.23668 12.6433L5.36529 12.1293C6.01454 11.7289 6.88092 11.2674 7.96794 10.8401C8.05709 10.8051 8.14859 10.7712 8.24212 10.7386C8.17387 10.8496 8.13739 10.9679 8.13249 11.0937C8.10231 11.8741 8.65184 12.3539 9.23668 12.6433Z"
                                                fill="#353535"></path>
                                            <path
                                                d="M10.5681 13.2137L10.8911 14.2666V15.3333H7.04458V13.4912L7.04533 12.7523L10.5681 13.2137Z"
                                                fill="#353535"></path>
                                        </svg>
                                        {jockey.jockey_old}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                             viewBox="0 0 14 14" fill="none" className="me-1 ms-1">
                                            <path
                                                d="M2.91675 6.99999H11.0834M11.0834 6.99999L7.00008 2.91666M11.0834 6.99999L7.00008 11.0833"
                                                stroke="#1F3735" strokeWidth="1.66" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                        </svg>
                                        {jockey.jockey_new}
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                             xmlns="http://www.w3.org/2000/svg" className="ms-1">
                                            <rect width="20" height="20" rx="10" fill="#1F3735"></rect>
                                            <path
                                                d="M12.9744 9.5241C12.7352 9.53708 12.4925 9.55233 12.2501 9.57119C11.4973 9.62941 10.8503 9.7092 10.3063 9.81124C9.41445 9.95786 8.54989 10.1627 7.82151 10.4492C6.5774 10.9382 5.62006 11.4654 4.93541 11.9047C4.56066 10.7176 3.8904 5.6833 8.4715 5.12701C8.55287 4.86059 8.78536 4.66666 9.06295 4.66666C9.32689 4.66666 9.55138 4.8414 9.64288 5.08755C11.6731 5.20757 12.7236 6.41117 13.2421 8.48304L15.3333 9.45641C14.7526 9.45466 13.9159 9.46665 12.9744 9.5241Z"
                                                fill="#FFE700"></path>
                                            <path
                                                d="M10.3811 12.602C9.8245 12.4828 8.49241 12.0943 8.53048 11.1097C8.54264 10.7967 8.9899 10.5504 9.69439 10.3625L10.3811 12.602Z"
                                                fill="#FFE700"></path>
                                            <path
                                                d="M10.0844 10.277C11.0314 10.1073 12.0314 10.0079 12.9403 9.95081L12.9606 9.97141L13.5515 11.4228C13.5662 11.4564 13.5732 11.4951 13.5732 11.5349C13.5732 11.6939 13.4475 11.8232 13.2912 11.8232H12.8214V12.8241C12.8214 13.6049 12.2038 14.2372 11.4407 14.2372H11.2989L10.0844 10.277Z"
                                                fill="#FFE700"></path>
                                            <path
                                                d="M9.23668 12.6433L5.36529 12.1293C6.01454 11.7289 6.88091 11.2674 7.96793 10.8401C8.05709 10.8051 8.14859 10.7712 8.24212 10.7386C8.17386 10.8496 8.13739 10.9679 8.13249 11.0937C8.10231 11.8741 8.65184 12.3539 9.23668 12.6433Z"
                                                fill="#FFE700"></path>
                                            <path
                                                d="M10.5681 13.2137L10.8911 14.2666V15.3333H7.04458V13.4912L7.04533 12.7523L10.5681 13.2137Z"
                                                fill="#FFE700"></path>
                                        </svg>
                                    </p>
                                </td>
                            </tr>
                        </React.Fragment>)
                    })}
                    </tbody>
                </table>}

            {
                jokeyChanges.length === 0 &&
                <div className={"d-flex flex-column justify-content-center align-content-center align-items-center"}
                     style={{minHeight: '380px'}}>

                    <p className={"text-green text-xsmall text-bold text-center"}>Şuan jokey değişikliği bulunmuyor!</p>
                </div>
            }
        </div>
    </>
}
